import { effect, inject, Injectable, signal } from '@angular/core';
import { ProfilePhotoApi } from '@/core/user/profile-photo-api.service';
import { AuthStore } from '@/features/auth-store.service';

@Injectable({ providedIn: 'root' })
export class ProfilePhotoStore {
  private readonly profilePhotoApi = inject(ProfilePhotoApi);
  private readonly authStore = inject(AuthStore);

  private readonly _photo = signal<string | undefined>(undefined);
  private readonly _loading = signal(false);
  private requestedForEmail: string | undefined;

  public readonly photo = this._photo.asReadonly();

  constructor() {
    effect(() => {
      if (!this.authStore.isAuthenticated()) this.clear();
    });
  }

  async loadOwnPhoto(): Promise<void> {
    const email = this.authStore.currentUser()?.email;
    if (this._loading() || email === undefined || email === this.requestedForEmail) return;

    this.requestedForEmail = email;
    this._loading.set(true);
    try {
      const photo = await this.profilePhotoApi.getOwnProfilePhoto();
      if (this.authStore.currentUser()?.email === email) this._photo.set(photo);
    } catch {
      this._photo.set(undefined);
    } finally {
      this._loading.set(false);
    }
  }

  private clear(): void {
    this.requestedForEmail = undefined;
    this._photo.set(undefined);
  }
}
